import { render, staticRenderFns } from "./MobileNav.vue?vue&type=template&id=c0f48b58"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"
import style0 from "./MobileNav.vue?vue&type=style&index=0&id=c0f48b58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BNavbarToggle, BButton, BNavForm, BNavItem, BNavbarNav, BFormInput, BInputGroupAppend, BInputGroup, BCollapse, BNavbar} from 'bootstrap-vue'
    installComponents(component, {BNavbarToggle, BButton, BNavForm, BNavItem, BNavbarNav, BFormInput, BInputGroupAppend, BInputGroup, BCollapse, BNavbar})
    

export default component.exports